var React = require('react');

function ShareInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd","transform":"matrix(1 0 0 -1 0 20)"},[React.createElement("rect",{"width":"14","height":"2","x":"1","key":0}),React.createElement("rect",{"width":"7","height":"2","x":"11.5","y":"2.5","transform":"rotate(-90 15 3.5)","key":1}),React.createElement("rect",{"width":"7","height":"2","x":"-2","y":"2.5","transform":"rotate(-90 1.5 3.5)","key":2}),React.createElement("path",{"d":"M9.737 17.122a1.956 1.956 0 0 1-2.765 0l-4.645-4.644 1.202-1.202 3.976 3.975-.001-9.76h1.7l.001 9.76 3.975-3.975 1.202 1.202z","key":3})]));
}

ShareInline.defaultProps = {"width":"17","height":"20","viewBox":"0 0 17 20"};

module.exports = ShareInline;

ShareInline.default = ShareInline;
